<template>
  <ul>
    <li
      v-for="(item, index) in items"
      :key="index"
      @click="itemClicked(item)"
    >
      <div
        class="item-thumbnail"
      >
        <img
          class="item-image"
          :src="item.thumbnail || blank"
        >
      </div>
      <div class="item-details">
        <p class="item-title">
          {{ item.name }}
        </p>
        <p class="item-description">
          {{ item.description }}
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
import Blank from '@/assets/item-blank.png'

export default {
    name: 'ItemList',
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    data() {
      return {
        blank: Blank
      }
    },
    methods: {
        itemClicked(key) {
            this.$emit('item-clicked', key)
        }
    }
}
</script>

<style lang="scss" scoped>
ul {
    list-style: none;
    margin: 0;
    padding: 0;
}
li {
    @include flex-horizontal;
    align-items: center;
    min-height: 70px;
    border-bottom: 1px solid #c8c8c8;
    cursor: pointer;
}
.item-details {
  height: 100%;
  padding: 0.5rem;
  text-align: left;
  .item-title {
    font-size: 1.2rem;
    font-weight: bold;
  }
}
.item-thumbnail {
  flex-shrink: 0;
  justify-self: flex-start;
  align-self: flex-start;
}
img {
    height: 100%;
    width: 70px;
}
</style>